const ComponentNotFound = ({ module }) => {
  console.warn("Module", module.model.apiKey, "not found.")
  return null
}

export default ComponentNotFound
